import axios from "axios";

const instance = (jwt) => {

    if(jwt){
        return axios.create({
            baseURL: process.env.REACT_APP_BACKEND,
            //  baseURL: "http://localhost:1337/",
            // baseURL: "https://odin-bf0c8.ew.r.appspot.com/",
            headers: {
                'Authorization': 'Bearer ' + jwt,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
          });
    }else{
        return axios.create({
            baseURL: process.env.REACT_APP_BACKEND,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
          });
    }

    
} 

export default instance 

